import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from "axios";
// main.js or main.ts
// import 'bootstrap/dist/css/bootstrap.min.css';
// import 'bootstrap/dist/js/bootstrap.bundle.min.js';


// axios.defaults.baseURL = "https://stratabackend.dotlinkertech.com/api/" 
// axios.defaults.baseURL = "https://fd84-152-59-167-213.ngrok-free.app/api/" 
// axios.defaults.baseURL = "http://localhost:50013/api/" 

const isLocalhost = window.location.hostname === "localhost";

axios.defaults.baseURL = isLocalhost
    ? "http://localhost:50013/api/" // Localhost API
    : "https://stratabackend.dotlinkertech.com/api/"; // Live API


createApp(App).use(store).use(router).mount('#app')







